import React from 'react';

export default function MapModal({url, title = 'Map', onClose}){
  if(!url) return null;
  return (
    <div className="modal" role="dialog" aria-modal="true" aria-label={`Map for ${title}`} onClick={onClose}>
      <div className="box" onClick={e=>e.stopPropagation()} style={{maxWidth:900, padding:12}}>
        <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
          <strong style={{color:'#c9a62b'}}>{title}</strong>
          <div style={{display:'flex',gap:8}}>
            <a href={url} target="_blank" rel="noopener noreferrer" className="btn" style={{padding:'8px 10px'}}>Open in new tab</a>
            <button className="btn" onClick={onClose} aria-label="Close map">Close</button>
          </div>
        </div>
        <div style={{height:560}}>
          <iframe
            title={`map-${title}`}
            src={url}
            style={{width:'100%',height:'100%',border:0,borderRadius:8}}
            loading="lazy"
          />
        </div>
      </div>
    </div>
  );
}
